import { Store } from '../../typings';

const isControlHasFlatValue = (store: Store, controlName: string, sectionId: string): boolean | undefined => (
  store.controls.sections[sectionId] && store.controls.sections[sectionId][controlName]
    ? store.controls.sections[sectionId][controlName].flatValue
    : undefined
);

export default isControlHasFlatValue;
